/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m22.9512 24.0706h-6.115-1.358-6.114v-.682c0-.748.587-1.529 1.305-1.735l3.45-.988v-1.895l-.002-.007c-1.217-.77-2.036-2.21-2.036-3.858 0-2.46 1.825-4.456 4.076-4.456 2.25 0 4.076 1.996 4.076 4.456 0 1.651-.821 3.093-2.042 3.862l.004.003v1.895l3.448.988c.72.206 1.308.987 1.308 1.735zm7.594-17.413h-18.307l-2.482-2.267c-.273-.251-.642-.391-1.029-.391h-7.273c-.804 0-1.454.596-1.454 1.329v21.26c0 .735.65 1.328 1.454 1.328h29.091c.804 0 1.455-.593 1.455-1.328v-18.602c0-.734-.651-1.329-1.455-1.329z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;